import React from "react";
import Spinner, { type SpinnerProps } from "react-bootstrap/Spinner";
import "./CustomSpinner.scss";

function CustomSpinner({
  isPrimary,
  className = "",
  ...restProps
}: SpinnerProps & { isPrimary?: boolean }) {
  return (
    <Spinner
      animation="border"
      role="status"
      className={`${isPrimary ? "primary-custom-spinner" : ""} ${className}`}
      {...restProps}
    >
      <span className="visually-hidden">Loading...</span>
    </Spinner>
  );
}

export { CustomSpinner };
